import React, { useState, useCallback } from "react";
import { Container, Row, Card, CardHeader, Button } from "reactstrap";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import BreadCrumb from '../../Components/Common/BreadCrumb';
import NoteModal from "./NoteModal";
import NotesTable from "./NotesTable";

const Notes = () => {
    document.title = "Pregled bilješki";
    const noteTypes = [
        { id: 0, name: "Odaberite tip bilješke" },
        { id: 1, name: "Brza pošta" },
        { id: 2, name: "Narudžba" },
        { id: 3, name: "Revers" },
        { id: 4, name: "Bilješke dijelovi" },
        { id: 5, name: "Ostalo" }
    ];
    const [modal, setModal] = useState(false);
    const toggleModal = useCallback(() => {
        setModal(!modal)
    }, [modal]);

    return (
        <div className="page-content">
            <ToastContainer closeButton={false} limit={2} />
            <NoteModal isEdit={false} show={modal} onCloseClick={() => toggleModal()} />
            <Container fluid>
                <BreadCrumb title="Pregled bilješki" pageTitle="Bilješke" />
                <Row className="g-4 mb-3">                    
                    <div className="col-sm-3 ms-auto">
                        <div className="d-flex justify-content-sm-end gap-2">
                            <Button color="success" id="add-part-btn" outline onClick={() => {toggleModal()}}>
                                <i className="ri-add-line align-bottom me-1"/> Dodaj bilješku
                            </Button>
                        </div>
                    </div>
                </Row>
                <NotesTable />              
            </Container>
        </div>
    );
};

export default Notes;